<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("linemente.title_edit") }}</h1>
    <form>
      <!-- 編集 -->
      <b-card :title="this.$i18n.t('linemente.label_edit')" class="w-50">
            <b-form-group
              id="lineId"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('linemente.label_line_id')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="lineId" disabled=true :placeholder="this.$i18n.t('linemente.placeholder_line_id')" maxlength="4"></b-form-input>
            </b-form-group>
            <b-form-group
              id="lineName"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('linemente.label_line_name_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="lineName" :placeholder="this.$i18n.t('linemente.placeholder_line_name')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="base"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('linemente.label_base')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="base" disabled=true :options="baseOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="lineKind"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('linemente.label_line_kind')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="lineKind" disabled=true :options="lineKindOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="back" class="float-left px-5">{{ $i18n.t("linemente.label_back") }}</b-button>
            </div>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("linemente.button_update") }}</b-button>
            </div>
      </b-card>
    </form>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('linemente.info_update')" :titleMsg="this.$i18n.t('linemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  created () {
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.searchBase()
    this.searchLineKind()

    // 値セット
    this.lineId = this.$store.store.state.lineId
    this.lineName = this.$store.store.state.lineName
    this.base = this.$store.store.state.baseId
    this.lineKind = this.$store.store.state.lineKindId
    console.log(this.from)
    this.$store.store.state.loading = false
    document.body.style.overflow = 'auto'

    // 検索条件セット
    this.searchLineId = this.$store.store.state.searchLineId
    this.searchLineName = this.$store.store.state.searchLineName
    this.searchBaseId = this.$store.store.state.searchBaseId
    this.searchLineKindId = this.$store.store.state.searchLineKindId
  },
  data () {
    return {
      lineId: null,
      lineName: null,
      baseList: null,
      lineKindList: null,
      searchLineId: null,
      searchLineName: null,
      searchBaseId: null,
      searchLineKindId: null,
      currentPage: 1,
      perPage: 5,
      baseOptions: [],
      lineKindOptions: [],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      errMsg: '',
      errSbj: ''
    }
  },
  methods: {
    regist: function () {
      // 入力値チェック
      if (this.lineName === null || this.lineName === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_line_name_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.lineName)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_line_name_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (this.base === null || this.base === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_base_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (this.lineKind === null || this.lineKind === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('linemente.err_line_kind_hissu')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.lineId = String(this.lineId)
      reqObj.lineName = this.lineName
      reqObj.base = this.base
      reqObj.lineKind = this.lineKind

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/line/update', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    searchBase: function () {
      // 拠点取得
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      this.$axios
        .post(window.END_POINT + '/master/base/select', reqObj, {
          'headers': headers
        })
        .then(res => {
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var baseList = res.data.base
            var bases = []

            // 整形
            for (var i = 0; i < baseList.length; i++) {
              var base = {}
              base.value = baseList[i].base_id
              base.text = baseList[i].base_name
              bases.push(base)
            }
            // 一旦データクリア
            this.baseOptions.splice(0)
            // データセット
            this.baseOptions.splice(0, 0, ...bases)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          alert(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    searchLineKind: function () {
      // ライン種別取得
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      this.$axios
        .post(window.END_POINT + '/master/lineKind/select', reqObj, {
          'headers': headers
        })
        .then(res => {
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var lineKindList = res.data.lineKind
            var lineKinds = []

            // 整形
            for (var i = 0; i < lineKindList.length; i++) {
              var lineKind = {}
              lineKind.value = lineKindList[i].line_kind_id
              lineKind.text = lineKindList[i].line_kind_name
              lineKinds.push(lineKind)
            }
            // 一旦データクリア
            this.lineKindOptions.splice(0)
            // データセット
            this.lineKindOptions.splice(0, 0, ...lineKinds)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          alert(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    back: function () {
      var searchFlg = 1
      var path = '/linemente'
      this.$router.push({ path: path, query: {searchFlg: [searchFlg], searchLineId: [this.searchLineId], searchLineName: [this.searchLineName], searchBaseId: [this.searchBaseId], searchLineKindId: [this.searchLineKindId]} })
    },
    registConfirm: function () {
      this.$bvModal.hide('md-confirm')
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  },
  routes: [
    {
      path: '/linemente/:searchFlg/:searchLineId/:searchLineName/:searchBaseId/:searchLineKindId',
      name: 'linemente',
      components: './Linemente.vue'
    }
  ]
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/LinementeEdit.vue